var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from "react";
import { FormattedMessage } from "@irati/utils/lang";
import { H2 } from "@irati/ui/src/Typography";
import FullModal from "@irati/ui/src/FullModal";
import { getPackage } from "@irati/permissions/services/packages";
import authentication from "@irati/auth";
import Loading from "@irati/ui/src/Loading";
import { StyledDiv, StyledHR, StyledH4, StyledLabel3 } from "./styled";
import DealList from "../DealList";
import TagList from "../TagList";
var DEALS_TAB = "DEALS_TAB";
var TAGS_TAB = "TAGS_TAB";
var Modal = /** @class */ (function (_super) {
    __extends(Modal, _super);
    function Modal() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            showTab: TAGS_TAB,
            packageId: null,
            load: null,
            allowLoading: true
        };
        _this.onLabelClick = function (tab) {
            _this.setState({
                showTab: tab,
                allowLoading: true
            });
        };
        return _this;
    }
    Modal.prototype.componentDidMount = function () {
        var _this = this;
        var tenant = authentication.userTenant();
        var load = getPackage({ tenant: tenant }).then(function (packageId) {
            _this.setState({
                packageId: packageId
            });
        });
        this.setState({ load: load });
    };
    Modal.prototype.render = function () {
        var _this = this;
        var _a = this.state, packageId = _a.packageId, showTab = _a.showTab, load = _a.load;
        var onHide = this.props.onHide;
        return (React.createElement(FullModal, { show: true, onHide: onHide },
            React.createElement(StyledDiv, null,
                React.createElement(H2, null,
                    React.createElement(FormattedMessage, { id: "admin.components.modal.headerTwo" })),
                React.createElement(StyledH4, null,
                    React.createElement(FormattedMessage, { id: "admin.components.modal.headerFour" })),
                React.createElement(StyledLabel3, { selected: showTab === TAGS_TAB, onClick: function () { return _this.onLabelClick(TAGS_TAB); } },
                    React.createElement(FormattedMessage, { id: "admin.components.modal.label.categories" })),
                React.createElement(StyledLabel3, { selected: showTab === DEALS_TAB, onClick: function () { return _this.onLabelClick(DEALS_TAB); } },
                    React.createElement(FormattedMessage, { id: "admin.components.modal.label.perks" })),
                React.createElement(StyledHR, null),
                React.createElement("div", { className: "text-left" },
                    React.createElement(Loading, { load: load },
                        showTab === DEALS_TAB &&
                            React.createElement(DealList, { tagId: packageId, ignoreBlacklist: true, onSave: this.props.onSave }),
                        showTab === TAGS_TAB &&
                            React.createElement(TagList, { onSave: this.props.onSave }))))));
    };
    return Modal;
}(Component));
export default Modal;
